export const LittleRedAudioData = {
    global: {
        tempo: 63,
        signature: [6, 8],
    },
    voiceover: {
        id: "littleRed-voiceover",
    },
    background: {
        samplePool: ["strings-bg"],
        volume: -18,
        loopStart: 0,
        loopEnd: 126000,
        fadeOutDuration: 4,
    },
    sharedLoops: [
        {
            name: "harp-low",
            samplePool: ["harp-low"],
            length: "4m",
            volume: -6,
        },
        {
            name: "harp-high",
            samplePool: ["harp-high"],
            length: "4m",
            volume: -6,
        },
        {
            name: "felt-piano-texture",
            samplePool: ["felt-piano-texture"],
            length: "4m",
            volume: -12,
        },
        {
            name: "strings-minimal",
            samplePool: ["strings-minimal"],
            length: "4m",
            volume: -20,
        },
    ],
    scenes: [
        // 0: TITLES
        {
            name: "Intro",
            tracks: [
                { group: "harp-low" },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 8,
            worldBackgroundVolume: -128,
        },
        {
            name: "Camera 2",
            tracks: [
                { group: "harp-low" },
            ],
            fadeInDuration: 4,
            fadeOutDuration: 3,
            worldBackgroundVolume: -12,
        },
        {
            name: "Camera 3",
            tracks: [
                { group: "harp-low" },
                { group: "harp-high" },
                { group: "felt-piano-texture", volume: -20 },
            ],
            fadeInDuration: 4,
            fadeOutDuration: 3,
            worldBackgroundVolume: -12,
        },
        {
            name: "Camera 4",
            tracks: [
                { group: "harp-low", volume: -20 },
                { group: "harp-high" },
                { group: "felt-piano-texture", volume: -9 },
            ],
            fadeInDuration: 4,
            fadeOutDuration: 8,
            loopLength: "4m",
            worldBackgroundVolume: -16,
        },
        {
            name: "Camera 5",
            fadeInDuration: 2,
            fadeOutDuration: 8,
            loopLength: "4m",
            tracks: [
                { group: "strings-minimal" },
                {
                    samplePool: ["harp-minimal"],
                    length: "4m",
                    velocity: 0.8,
                },
            ],
            worldBackgroundVolume: -40,
        },
        {
            name: "Camera 6",
            fadeInDuration: 4,
            fadeOutDuration: 8,
            loopLength: "4m",
            tracks: [
                { group: "strings-minimal" },
            ],
            worldBackgroundVolume: -48,
        },
    ]
};
